// extracted by mini-css-extract-plugin
export default {"container":"SuccessQrChangeModal_container__INk6i","icon":"SuccessQrChangeModal_icon__IU1hv","text":"SuccessQrChangeModal_text__EHDOv"};